<template>
  <section class="ability-cert">
    <div class="container">
      <h2 class="section-title">{{ $t('student.certificationTitle') }}</h2>
      
      <div class="cert-features">
        <div class="feature-card">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('features.assessment') }}</h3>
          <p>{{ $t('contact.name') }}</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="13 2 13 9 20 9"/>
            </svg>
          </div>
          <h3>{{ $t('student.certificationTitle') }}</h3>
          <p>{{ $t('student.certificationDesc') }}</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>
              <path d="M12 5v14M5 12h14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('features.record') }}</h3>
          <p>{{ $t('contact.company') }}</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('features.allocation') }}</h3>
          <p>{{ $t('contact.cooperation') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AbilityCertification'
}
</script>

<style scoped>
.ability-cert {
  padding: 5rem 2rem;
  background: 
    radial-gradient(circle at 100% 0%, rgba(0, 217, 255, 0.08) 0, transparent 50%),
    radial-gradient(circle at 0% 100%, rgba(138, 43, 226, 0.08) 0, transparent 50%),
    #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 3rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cert-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.feature-card {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.feature-card:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.feature-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 1rem;
  color: #00D9FF;
}

.feature-icon svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 0 10px rgba(0, 217, 255, 0.3));
}

.feature-card h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 0.75rem;
}

.feature-card p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .ability-cert {
    padding: 3rem 1.5rem;
  }
}
</style>
